import React, { useEffect, useRef, useState } from "react";
import { Box } from "@mui/material";
import GenericTable from "../../GenericTable/GenericTable";
import TableToolbar from "../../GenericTable/TableToolbar";
import WorkflowSidebar from "../../workflowActions/WorkflowSidebar";
import { combinedColumns, combinedRows } from "./combinedReview.data";
import { mockFiles } from "../../SelectFilesMenu/mockFiles.data";
import {
  exportCombinedReviewCSV,
  getCombinedReviewData,
  initialPayloadConst,
  resetCombinedPayload,
  setCombinedPayload,
  setPayload,
} from "./CombinedReviewSlice";
import { useDispatch, useSelector } from "react-redux";
import { clearSelectedFileIds, getSelectedAuditedFilesMenuData, setSelectedFileIds } from "../../SelectFilesMenu/SelectFilesMenuSlice";
import {
  getEnhanceAuditResults,
  getEnhancePlusFlags,
  getEnhanceWorkflowEpisodeDetails,
  REQUEST_STATUS,
  resetEpisodeReviewData,
  unassignEpisode,
} from "../EnhanceWorkflow/EnhanceWorkflowSlice";
import CombinedFilterModal from "./CombinedFilter/CombinedFilterModal";
import EpisodeReview from "../EpisodeReview/EpisodeReview";
import { downloadBlob } from "../../../web-workflow/utils/util";
import { toast } from "react-toastify";
import { useNavigate, useParams } from "react-router-dom";

export default function CombinedReview({ activeModule, onModuleChange }) {
  const [sidebarSelected, setSidebarSelected] = useState("");
  const [search, setSearch] = useState("");
  const [selectedRows, setSelectedRows] = useState([]);
  const { episodeId } = useParams();
  // Pre-select all files by default, like your reference screenshot ("3 Files Selected")
  // const [selectedFileIds, setSelectedFileIds] = useState([]);
  const [view, setView] = useState("list"); 
  const navigate = useNavigate();
  const [selectedEpisode, setSelectedEpisode] = useState(null); 
  const currentUserId = sessionStorage.getItem("userId");
  const [version, setVersion] = useState("Version");
  const [openFilter, setOpenFilter] = useState(false);
  const [isRecalledView, setIsRecalledView] = useState(false);
  const [isDownloading, setIsDownloading] = useState(false);
  const [isSelectAll, setIsSelectAll] = useState(false);
   const [isUnassignedView, setIsUnassignedView] = useState(false);
  const lastFetchedPayloadRef = useRef(null);
  const [filterResetKey, setFilterResetKey] = useState(0);
  const [pageSizeReady, setPageSizeReady] = useState(false);
  const [searchType, setSearchType] = useState("episode");
  const {
    episodeDetails,
    plusFlags,
    auditResults,
    payload: enhancePayload,
  } = useSelector((state) => state.codeEnhance);
  const { payload, combinedReviewData } = useSelector(
    (state) => state.combinedReview,
  );
  const { data, status } = useSelector(
    (state) => state.selectedAuditedFiles.files,
  );
  const selectedFileIds = useSelector(
     (state) => state.selectedAuditedFiles.selectedFileIds,
    );
  
  const combinedReviewDataLoading =
    combinedReviewData.status === REQUEST_STATUS.LOADING;
  const dispatch = useDispatch();
  const combinedReviewRows = combinedReviewData.data.data ?? [];
  const COMBINED_REVIEW_BOOKKEEPING_KEYS = [
  "page_number",
  "page_size",
  "sort_by",
  "sort_order",
  "unassigned_page",
  "is_flagged",
  "recall",
];
const pageSizeRef = useRef(10);
const hasActiveFilters = Object.keys(payload).some((key) => {
  if (COMBINED_REVIEW_BOOKKEEPING_KEYS.includes(key)) return false;

  const current = payload[key];
  const initial = initialPayloadConst[key];

  if (Array.isArray(current) || Array.isArray(initial)) {
    const a = Array.isArray(current) ? current : [];
    const b = Array.isArray(initial) ? initial : [];
    if (a.length !== b.length) return true;
    return a.some((v, i) => v !== b[i]);
  }

  return current !== initial;
});
  const combinedRows = combinedReviewRows.map((item) => ({
    episodeId: item.episode_identifier,
    mrn: item.medical_record_number,
    hcpLineId: item.hcp_line_id,
    priority: item.priority,
    pallasPriority: item.pallas_priority || "-------",
    admitDate: item.admission_date,
    dischargeDate: item.discharge_date,
    speciality :item.speciality,
    los: item.length_of_stay,
    coderName:item.coder_name,
     predictedDrg1:item.predicted_drg1,
     predictedDrg2:item.predicted_drg2,
     principalDiagnosis:item.principal_diagnosis,
     principalProcedureCode:item.procedure_code,
    healthFund: item.health_fund,
    auditStatus:item.status,
    actualDrg: item.actual_drg || "-------",
    auditRuleRefNo: item.audit_rule_ref_no?.join(", ") || "-------",
    auditShortDescription:
      item.audit_short_description?.join(", ") || "-------",
    actualReimbursement: item.actual_reimbursement,
    predictedReimbursement1: item.predicted_reimbursement1,
    predictedReimbursement2: item.predicted_reimbursement2,
    delta1: item.delta1,
    delta2: item.delta2,
    isDrgDifferent: item.is_drg_different ? "Yes" : "No",
    assignedTo:item.assigned_to
  }));

const files = data.map((item) => ({
  id: item.header_id,
  fileName: item.file_name?.join(", ") || "",
  dateRange: `${item.start_date} - ${item.end_date}`,
  loadId: item.load_id,
  total_records: item.total_records
}));
  const selectedFileNames = files
    .filter((file) => selectedFileIds.includes(file.id))
    .map((file) => file.fileName);
  const filteredRows = search
    ? combinedRows.filter((r) =>{
      const field = searchType === "mrn" ? r.mrn : r.episodeId;
      return field?.toLowerCase().includes(search.toLowerCase());
    }
      )
    : combinedRows;

useEffect(() => {
  if (!pageSizeReady) return;

  const payloadKey = JSON.stringify(payload);
  if (lastFetchedPayloadRef.current === payloadKey) return;
  lastFetchedPayloadRef.current = payloadKey;

  dispatch(getCombinedReviewData(payload));
}, [dispatch, payload, pageSizeReady]);
useEffect(() => {
  if (!episodeId) {
    setView("list");
    setSelectedEpisode(null);
    return;
  }

  setSelectedEpisode({ hcpLineId: episodeId });
  dispatch(getEnhanceWorkflowEpisodeDetails(episodeId));
  dispatch(getEnhancePlusFlags(episodeId));
  dispatch(getEnhanceAuditResults(episodeId));
  setView("review");
}, [episodeId, dispatch]);
const handleFilesApply = (ids) => {
  // setSelectedFileIds(ids);
  dispatch(setSelectedFileIds(ids));
  const selectedFiles = files.filter((file) => ids.includes(file.id));
  dispatch(
    setPayload({
      header_id: selectedFiles.map((file) => file.id),
      file_name: selectedFiles.map((file) => file.fileName),   // ← changed from file_type
      page_number: 1,
      unassigned_page: isUnassignedView,
      is_flagged: isRecalledView,
      recall: isRecalledView,
    }),
  );
};
// Ensure the shared files list is loaded
useEffect(() => {
  dispatch(getSelectedAuditedFilesMenuData({ pageNumber: 1, search: "" }));
}, [dispatch]);

// Re-apply already-selected files into THIS module's payload on mount
useEffect(() => {
  if (selectedFileIds.length === 0) return;


  dispatch(
    setPayload({
      header_id: selectedFileIds,
      page_number: 1,
      unassigned_page: isUnassignedView,
      is_flagged: isRecalledView,
      recall: isRecalledView,
    }),
  );
}, [selectedFileIds]);
  const handleGlobalSearch = (value, type="episode") => {
    setSearch(value);
  setSearchType(type); 
    dispatch(
      setPayload({
        episode_identifier: type === "episode" && value ? [value] : [],
        medical_record_number: type === "mrn" && value ? [value] : [],
        is_global_search: Boolean(value),
        page_number: 1,
        unassigned_page: isUnassignedView, 
        is_flagged: isRecalledView,
        recall:isRecalledView
      }),
    );
  };
  const handleSortChange = ({ field, order }) => {
    dispatch(
      setPayload({
        sort_by: field,
        sort_order: order.toUpperCase(),
        page_number: 1,
        unassigned_page: isUnassignedView, 
        is_flagged: isRecalledView, 
        recall:isRecalledView
      }),
    );
  };
  const handlePageChange = (page) => {
    console.log("Clicked Page:", page);
    dispatch(
      setPayload({
        page_number: page + 1,
        unassigned_page: isUnassignedView,
        is_flagged: isRecalledView,
        recall:isRecalledView   
      }),
    );
  };
const handlePageSizeChange = (newSize) => {
  setPageSizeReady(true);
   pageSizeRef.current = newSize;
  if (newSize === payload.page_size) return;
  dispatch(
    setPayload({
      page_size: newSize,
      page_number: 1,
      unassigned_page: isUnassignedView,
      is_flagged: isRecalledView,
      recall: isRecalledView,
    }),
  );
};
  const versionMap = {
    "Version 10": "10",
    "Version 11": "11",
    "Version 12": "12",
    "Version 6": "6",
    "Version 8": "8",
  };

  const handleVersionChange = (value) => {
    setVersion(value);

    dispatch(
      setPayload({
        version: versionMap[value] || value,
        page_number: 1,
      }),
    );
  };
  const handleEpisodeClick = (row) => {
    navigate(`/Review-Enhance-Workflow/${row.hcpLineId}`);
    setSelectedEpisode(row);
    dispatch(getEnhanceWorkflowEpisodeDetails(row.hcpLineId));
    dispatch(getEnhancePlusFlags(row.hcpLineId));
    dispatch(getEnhanceAuditResults(row.hcpLineId));
    setView("review");
  };
  const handleBackToList = () => {
    navigate("/Review-Enhance-Workflow");
    setView("list");
    setSelectedEpisode(null);
    dispatch(resetEpisodeReviewData());
  };
  const handleUnassignConfirm = async (reason) => {
    const hcpLineId = selectedEpisode?.hcpLineId;
    if (!hcpLineId) {
      toast.error("Missing episode reference");
      return;
    }

    try {
      const res = await dispatch(
        unassignEpisode({
          hcp_lines: [hcpLineId],
          unassigned_by: Number(currentUserId),
          unassignment_reason: reason,
          select_all: false,
          user_id: currentUserId,
          filter: enhancePayload,
        }),
      ).unwrap();

      toast.success(res?.message || "Episode unassigned successfully");
        if (sidebarSelected === "Unassigned Episodes") {
    dispatch(getCombinedReviewData({ ...payload, unassigned_page: true }));
  } else if (sidebarSelected === "Recalled Episodes") {
    dispatch(getCombinedReviewData({ ...payload, is_flagged: true,recall:true }));
  } else {
    dispatch(getCombinedReviewData(payload));
  }
      handleBackToList();
     
    } catch (err) {
      toast.error(err || "Something went wrong");
      throw err;
    }
  };
  const handleAssignSuccess = () => {
  if (sidebarSelected === "Unassigned Episodes") {
    dispatch(getCombinedReviewData({ ...payload, unassigned_page: true }));
  } else if (sidebarSelected === "Recalled Episodes") {
    dispatch(getCombinedReviewData({ ...payload, is_flagged: true,recall:true }));
  } else {
    dispatch(getCombinedReviewData(payload));
  }

  handleBackToList();
};
  const handleCombinedRefresh = () => {
    // setSelectedFileIds([]);
    dispatch(clearSelectedFileIds());
    setVersion("Version");
    setSearch(""); 
    dispatch(resetCombinedPayload());
    dispatch(
        setCombinedPayload({
          unassigned_page: isUnassignedView,
          is_flagged: isRecalledView,
          recall:isRecalledView,
          page_size: pageSizeRef.current,
        }),
      );
    setFilterResetKey((k) => k + 1);
  };
  if (view === "review") {
    return (
      <Box sx={{ height: "calc(95vh - 12px)", pt: 1.5, bgcolor: "#eef1f5" }}>
        <EpisodeReview
          data={episodeDetails?.data?.data}
          onBack={handleBackToList}
          activeModule={activeModule}
          plusFlags={plusFlags}
          auditResults={auditResults.data}
          onUnassign={handleUnassignConfirm}
          loading={episodeDetails.status === REQUEST_STATUS.LOADING}
          error={
            episodeDetails.status === REQUEST_STATUS.FAILURE
              ? episodeDetails.error || "Something went wrong"
              : null
          }
          hideUnassign={sidebarSelected === "Unassigned Episodes"} 
          onAssignSuccess={handleAssignSuccess} 
        />
      </Box>
    );
  }
  const handleDownload = async () => {
    const { page_number, page_size, ...exportPayload } = payload;
    setIsDownloading(true);
    try {
      const response = await dispatch(
        exportCombinedReviewCSV(exportPayload),
      ).unwrap();
      const fileUrl = response?.data?.file_url;
      const Querymessage = response?.data?.message;
      toast.success(Querymessage);
      if (fileUrl) {
        // console.log(fileUrl, "acess the url");
        const link = document.createElement("a");
        link.href = fileUrl;
        link.setAttribute("download", "auditfile.csv");
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      } else {
        console.log("file URL not found in reposne");
      }
    } catch (err) {
      toast.error(err || "Failed to export CSV");
    } finally {
      setIsDownloading(false);
    }
  };
  return (
    <Box
      sx={{
        display: "flex",
        height: "calc(95vh - 14px)",
        overflow: "hidden",
        pt: 1.5,
        // bgcolor: "#eef1f5",
      }}
    >
      <WorkflowSidebar
        selected={sidebarSelected}
        onSelect={setSidebarSelected}
        setSidebarSelected={setSidebarSelected}
        activeModule={activeModule}
        onModuleChange={onModuleChange}
        selectedRows={selectedRows}
        isRecalledView={isRecalledView}
        setIsRecalledView={setIsRecalledView}
        isUnassignedView={isUnassignedView}
         setIsUnassignedView = {setIsUnassignedView}
        isSelectAll={isSelectAll}
        onAssignComplete={() => {
          setSelectedRows([]);
        }}
      />

      <Box
        sx={{ flex: 1, display: "flex", flexDirection: "column", minWidth: 0 }}
      >
        <TableToolbar
          activeModule={activeModule}
          onModuleChange={onModuleChange}
          onSearch={handleGlobalSearch}
          showVersionInfo={true}
          files={files}
          selectedFileIds={selectedFileIds}
          onFilesApply={handleFilesApply}
          filesLoading={false}
          version={version}
          setVersion={setVersion}
          onVersionChange={handleVersionChange}
          setSidebarSelected={setSidebarSelected}
          onFilterClick={() => setOpenFilter(true)}
          selectedFileNames={selectedFileNames}
          onDownload={handleDownload}
          downloadLoading={isDownloading}
          isRecalledView={isRecalledView}
          setIsRecalledView={setIsRecalledView}
          isUnassignedView={isUnassignedView}
          setIsUnassignedView = {setIsUnassignedView}
          onRefresh={handleCombinedRefresh}
          hasActiveFilters={hasActiveFilters}
        />

        <Box
          sx={{
            flex: 1,
            overflow: "auto",
            display: "flex",
            flexDirection: "column",
            minHeight: 0,
            "& .MuiPaper-elevation0": {
              height: "calc(100vh - 110px)",
            },
          }}
        >
          <GenericTable
            activeModule={activeModule}
            columns={combinedColumns}
            rows={combinedRows}
            selectable
            serverMode
            loading={combinedReviewDataLoading}
            onSortChange={handleSortChange}
            onPageChange={handlePageChange}
            currentPage={(combinedReviewData.data?.page_number ?? 1) - 1}
            totalPages={combinedReviewData.data?.total_pages ?? 1}
            onRowClick={handleEpisodeClick}
            selectedRows={selectedRows}
            onSelectionChange={setSelectedRows}
            isSelectAll={isSelectAll}
            onSelectAllChange={setIsSelectAll}
            filterResetKey={filterResetKey}
              rowsPerPage={payload.page_size || 10}
  onPageSizeChange={handlePageSizeChange}
          />
        </Box>
      </Box>
      <CombinedFilterModal
        open={openFilter}
        onClose={() => setOpenFilter(false)}
        isUnassignedView={isUnassignedView}
        isRecalledView={isRecalledView}
      />
    </Box>
  );
}
